export default "__VITE_ASSET__C_6YQE3p__"